import { AUTH0_ROLES } from '@omnipresentgroup/constants';
import { useCompanyAvailableProducts } from '@omnipresentgroup/domains';
import { useMemo } from 'react';

import { useManagerUser } from './useManagerUser';

export const useContractorOnly = () => {
  const { authUser: user, companyId } = useManagerUser();

  const { data: companyAvailableProducts } = useCompanyAvailableProducts({
    companyId,
    enabled:
      user?.[AUTH0_ROLES] && user?.[AUTH0_ROLES].length > 0 && companyId !== '',
  });

  const isContractorOnly = useMemo(
    () =>
      !!companyAvailableProducts?.Contractor && !companyAvailableProducts?.EOR,
    [companyAvailableProducts?.Contractor, companyAvailableProducts?.EOR],
  );

  return { isContractorOnly };
};
